// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","publishFundButton":"_28irDwVbZJTUntQtiwSnhq","publishFundModalButtons":"xBNegVyfiav5xMwETI0Jf"};